<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.98908 17.2589C11.3241 17.2589 12.4063 16.3032 12.4063 14.8417V4H15.3052C15.1426 5.97723 17.1082 7.88718 19.2759 7.8435V10.5695C17.4221 10.5695 15.8457 9.78561 15.297 9.35059V14.8417C15.297 17.2589 13.3954 20 9.98908 20C6.58275 20 4.72266 17.2589 4.72266 14.8417C4.72266 11.43 8.33309 9.45136 10.7244 9.93497V12.7115C10.6041 12.669 10.2938 12.6061 10.0296 12.6061C8.68352 12.5564 7.57186 13.6482 7.57186 14.8417C7.57186 16.1767 8.65408 17.2589 9.98908 17.2589Z"
      fill="currentColor"
    />
  </svg>
</template>
